<script setup lang="ts">
import { X } from 'lucide-vue-next';

defineProps<{
  typedSearch: string;
  isTyping: boolean;
  showResults: boolean;
}>();
</script>

<template>
  <div class="add-more-parity-mock dark">
    <div class="add-more-header dark">
      <h2 class="centered-title">Add More</h2>
    </div>
    <div class="add-more-body dark">
      <div class="search-bar-parity dark">
        <div class="search-input-wrapper">
          <span>{{ typedSearch }}</span>
          <span class="cursor" :class="{ active: isTyping }">|</span>
        </div>
        <X :size="16" class="search-x" />
      </div>
      <div v-if="showResults" class="search-result-card-parity dark animate-in">
        <div class="result-header">Liverpool - Chelsea<p>Sat 12:30 • Premier League</p></div>
        <div class="result-selection">Chelsea<p>Full Time</p></div>
      </div>
    </div>
    <div class="add-more-footer dark"><button class="footer-btn-parity red">Add to bet</button></div>
  </div>
</template>

<style scoped>
.add-more-parity-mock { height: 100%; min-height: 600px; background: #09090b; display: flex; flex-direction: column; }
.add-more-header { padding: 24px; border-bottom: 1px solid rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: flex-start; position: relative; }
.centered-title { position: absolute; left: 50%; transform: translateX(-50%); font-size: 1.2rem; font-weight: 900; color: #fff; }

.add-more-body { padding: 40px; flex-grow: 1; display: flex; flex-direction: column; gap: 32px; }
.search-bar-parity { background: #000; border: 1px solid #27272a; padding: 16px 20px; border-radius: 12px; display: flex; justify-content: space-between; align-items: center; color: #fff; font-size: 1.1rem; font-weight: 500; }
.search-input-wrapper { display: flex; align-items: center; }

.cursor { color: #e21b0d; font-weight: 300; margin-left: 2px; animation: blink 1s step-end infinite; opacity: 1; }
@keyframes blink { from, to { opacity: 1; } 50% { opacity: 0; } }

.search-result-card-parity { border: 1.5px solid #3f3f46; border-radius: 16px; overflow: hidden; }
.result-header { padding: 16px 20px; background: #18181b; font-weight: 800; font-size: 1rem; border-bottom: 1px solid #27272a; color: #fff; }
.result-header p { font-size: 0.75rem; color: #71717a; font-weight: 400; margin-top: 4px; }
.result-selection { padding: 16px 20px; background: #000; font-weight: 900; font-size: 1.1rem; color: #fff; }
.result-selection p { font-size: 0.8rem; color: #71717a; font-weight: 400; margin-top: 4px; }

.add-more-footer { padding: 32px; border-top: 1px solid rgba(255,255,255,0.05); display: flex; justify-content: center; }
.footer-btn-parity { width: 100%; max-width: 500px; height: 56px; border-radius: 16px; border: none; font-weight: 900; font-size: 1.1rem; cursor: pointer; background: #e21b0d; color: #fff; box-shadow: 0 8px 24px rgba(226, 27, 13, 0.3); }

@media (max-width: 768px) {
  .add-more-body { padding: 24px; gap: 24px; }
  .add-more-header { flex-direction: column; align-items: flex-start; gap: 16px; padding: 16px 24px; }
  .centered-title { position: static; transform: none; font-size: 1.5rem; margin-top: 8px; }
  .search-bar-parity { padding: 12px 16px; font-size: 1rem; }
}

.animate-in { animation: fadeInUp 0.4s ease forwards; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>
